import { Node } from 'contensis-management-api/lib/models';
import { RequestHandler } from 'express';
import mapJson from 'jsonpath-mapper';
import { MigrateRequest, NodesResult } from '~/services';

import NodesMigrationService from '~/services/NodesMigrationService';
import mapAppErrorToObject from '~/transformations/mapAppErrorToObject';
import { saveRecorded } from '../mockingMiddleware';

export const returnNodes: RequestHandler = async (req, res, next) => {
  try {
    const { id, payload = {} }: { id?: string; payload?: MigrateRequest } =
      res.locals;

    // Add any id param to the get query
    if (id) payload.query = { ...(payload.query || {}), includeIds: [id] };

    const results = await new NodesMigrationService(payload, true).GetNodes();
    let mappedResults: Node[] | undefined;

    // Remap results to include only requested fields in REST response
    if (
      payload.query &&
      Array.isArray(payload.query?.fields) &&
      payload.query.fields.length > 0
    ) {
      // map results to include only fields
      const fieldMapping = payload.query.fields?.map<[string, any]>((key) => [
        key,
        key,
      ]);
      fieldMapping.push([
        'sys',
        { contentTypeId: 'sys.contentTypeId', id: 'sys.id' },
      ]);

      mappedResults = results.map((entry) =>
        mapJson(entry, Object.fromEntries(fieldMapping))
      );
    }

    const response = {
      committed: false,
      totalCount: results.length,
      items: mappedResults || results,
    };

    res.send(response);

    saveRecorded(req, res, {
      operation: 'returnNodes',
      response,
    });

    res.locals.response = response;
  } catch (ex: any) {
    res.locals.response = { error: mapAppErrorToObject(ex) };
    res.setHeader('expose-raw-errors', 'true');
    res.status(500).send(res.locals.response);
  }
  next();
};

export const deleteNodes: RequestHandler = async (req, res, next) => {
  const {
    payload = {},
    preview = true,
  }: {
    payload?: MigrateRequest;
    preview?: boolean;
  } = res.locals;

  let response = { committed: !preview } as Partial<NodesResult>;

  try {
    const migrationService = new NodesMigrationService(payload, preview);

    const results = await migrationService.DeleteNodes();
    response = { ...response, ...results };

    res.send(response);
  } catch (ex: any) {
    response = { ...response, error: mapAppErrorToObject(ex) };
    res.status(500).send(response);
  } finally {
    saveRecorded(req, res, {
      operation: 'deleteNodes',
      response,
    });
  }
};

export const migrateNodes: RequestHandler = async (req, res, next) => {
  const {
    payload = {},
    preview = true,
  }: {
    payload?: MigrateRequest;
    preview?: boolean;
  } = res.locals;
  let response = { committed: !preview } as Partial<NodesResult>;

  try {
    const migrationService = new NodesMigrationService(payload, preview);

    const results = await migrationService.MigrateNodes();
    response = { ...response, ...results };

    res.send(response);
  } catch (ex: any) {
    response = { ...response, error: mapAppErrorToObject(ex) };
    res.status(500).send(response);
  } finally {
    saveRecorded(req, res, {
      operation: 'migrateNodes',
      response,
    });
  }
  next();
};
